import { render, staticRenderFns } from "./DepositDetails.vue?vue&type=template&id=4f6eaf76&scoped=true"
import script from "./DepositDetails.vue?vue&type=script&lang=js"
export * from "./DepositDetails.vue?vue&type=script&lang=js"
import style0 from "./DepositDetails.vue?vue&type=style&index=0&id=4f6eaf76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6eaf76",
  null
  
)

export default component.exports